import { APP_CHANGE_ACTION_TYPE } from '../../constants/ReduxAsyncActions.constants';
import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import { INIT_STATE } from './AdLinks.constants';
import type { AdLinkState } from './AdLinks.types';
import type { AdLinkAction } from './actions';
import { ARCHIVE_LINK_ACTION_CONSTANTS, GET_AD_LINKS_ACTION_CONSTANTS, UPDATE_AD_LINKS } from './actions';

const handler = (state: WrappedReducer<AdLinkState>, action: AdLinkAction): WrappedReducer<AdLinkState> => {
  const { links } = state;

  switch (action.type) {
    case GET_AD_LINKS_ACTION_CONSTANTS.response:
      return { ...state, links: action.data, loading: false, hasLinksLoaded: true };

    case UPDATE_AD_LINKS:
      if (!links) {
        return state;
      }

      let updatedLink;

      let index = links.findIndex((link) => link.id === action.data.link_id);

      if (index !== -1) {
        updatedLink = {
          ...links[index],
          data: { ...action.data.data },
          archived: action.data.archived,
        };
      } else {
        index = links.length;
        updatedLink = { ...action.data, date: Date.now() };
      }

      const updatedLinks = [...links.slice(0, index), updatedLink, ...links.slice(index + 1)];

      return {
        ...state,
        links: updatedLinks,
        loading: false,
      };

    case ARCHIVE_LINK_ACTION_CONSTANTS.response:
      if (!links) {
        return state;
      }

      const archivedIndex = links.findIndex((link) => link.id === action.data.id);

      if (archivedIndex === -1) {
        return state;
      }

      const archivedLink = {
        ...links[archivedIndex],
        archived: action.data.archived,
      };

      const linksWithArchived = [...links.slice(0, archivedIndex), archivedLink, ...links.slice(archivedIndex + 1)];

      return {
        ...state,
        links: linksWithArchived,
        loading: false,
      };

    default:
      return state;
  }
};

const AdLinks = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_AD_LINKS_ACTION_CONSTANTS, ARCHIVE_LINK_ACTION_CONSTANTS],
  error: [GET_AD_LINKS_ACTION_CONSTANTS, ARCHIVE_LINK_ACTION_CONSTANTS],
  resetOn: [APP_CHANGE_ACTION_TYPE],
});

export default AdLinks;
